// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const calyrex_shadow: PokeData = {
  "id": 10194,
  "name": "calyrex-shadow",
  "height": 24,
  "weight": 536,
  "base_experience": 340,
  "types": [
    PokeType.PSYCHIC,
    PokeType.GHOST
  ],
  "api_moves": [
    "pound",
    "stomp",
    "double-kick",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "tail-whip",
    "disable",
    "mega-drain",
    "leech-seed",
    "growth",
    "solar-beam",
    "confusion",
    "psychic",
    "agility",
    "confuse-ray",
    "haze",
    "giga-drain",
    "shadow-ball",
    "future-sight",
    "helping-hand",
    "aromatherapy",
    "energy-ball",
    "nasty-plot",
    "psyshock",
    "heal-pulse",
    "hex",
    "grassy-terrain",
    "psychic-terrain",
    "life-dew",
    "astral-barrage"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "solar-beam",
    "psychic",
    "confuse-ray",
    "shadow-ball",
    "future-sight",
    "aromatherapy",
    "energy-ball",
    "grassy-terrain",
    "psychic-terrain",
    "life-dew",
    "shadow-dagger"
  ],
  "evolution_chain": {
    "id": 476,
    "item": null,
    "species": [
      {
        "name": "calyrex",
        "order": 898,
        "types": [
          PokeType.PSYCHIC,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 150,
    "ability_power": 165
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
